import { Component, Vue } from 'vue-property-decorator';
import { ProductFilterItem } from "@/components/CustomFilters/ProductFilters/ProductFilters";

@Component<AbstractFilters>({})
export default class AbstractFilters extends Vue {

  public setProductFilters(filters: ProductFilterItem): void {
    localStorage.setItem(`${this.$route.name}_productFilters`, JSON.stringify(filters));
  }

  public getProductFilters() {
    const filters = localStorage.getItem(`${this.$route.name}_productFilters`);

    if (filters) {
      var parsedobj = JSON.parse(JSON.stringify(filters))

      return parsedobj.productFilter;
    }

    return {};
  }

}
